import { Breadcrumb } from 'react-breadcrumbs';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

import HiringMeetingSection from './HiringMeetingSection';
import { useHiringMeetingTemplate } from '../../../../../hooks/queries/hiring-meeting-templates';
import { StyledContainer } from './styles';
import { correctPath } from 'libraries/gem';

const HiringMeetingTemplateDetails = () => {
  const { id } = useParams<{ id: string }>();

  const { data: hiringMeetingTemplate } = useHiringMeetingTemplate(id);

  return (
    <Breadcrumb
      data={{
        title: 'Details',
        pathname: correctPath(`/app/hiring-meeting-templates/${id}/details`),
      }}
    >
      <StyledContainer>
        <Helmet>
          <title>Details | {hiringMeetingTemplate?.name} | Gem Scheduling</title>
        </Helmet>
        <HiringMeetingSection />
      </StyledContainer>
    </Breadcrumb>
  );
};

export default HiringMeetingTemplateDetails;
